import React, { Component } from 'react';


class Token extends Component {
  constructor(props) {
    super(props);
    this.state = { jwt: '' };
  }

  render() {
    const headers = {
      codUsuario: 'ACRUZ',
      token: this.state.jwt,
      'Content-Type': 'application/json',
    };

    const body = {
      contrasena: 'noprod',
      idSistema: 169,
      loginUsuario: 'acruz',
    };

    return (
      <div>
        <button
          onClick={() => {
            fetch('http://172.20.200.45:8080/login-ws/usuario/autenticar', {
              method: 'POST',
              headers,
              body: JSON.stringify(body),
            })
          .then(response => response.json())
          .then((data) => {
            const jwt = data.usuario.userAccessToken;
            sessionStorage.setItem('token', jwt);
            this.setState({ jwt });
          });
          }}
        >
          Obtener token
        </button>
        <div>Token: {this.state.jwt}</div>
        <button
          onClick={() => {
            // fetch
            fetch('http://172.20.200.45:8080/sid-generico/areaVenta/accesoUsuarioListar', {
              method: 'POST',
              headers: {
                codUsuario: 'ACRUZ',
                token: this.state.jwt,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.state.jwt}`,
              },
              body: JSON.stringify(body),
            });

            // XHR
            // const data = JSON.stringify({
            //   contrasena: 'noprod',
            //   idSistema: 169,
            //   loginUsuario: 'acruz',
            // });
            //
            // const xhr = new XMLHttpRequest();
            // xhr.withCredentials = true;
            //
            // xhr.addEventListener('readystatechange', function() {
            //   if (this.readyState === 4) {
            //     console.log(this.responseText);
            //   }
            // });
            //
            // xhr.open('POST', 'http://172.20.200.45:8080/sid-generico/areaVenta/accesoUsuarioListar');
            // xhr.setRequestHeader('codusuario', 'ACRUZ');
            // xhr.setRequestHeader('token', this.state.jwt);
            // xhr.setRequestHeader('content-type', 'application/json');
            //
            // xhr.send(data);
          }}
        >
          Probar token
        </button>
      </div>
    );
  }

}

export default Token;



// WEBPACK FOOTER //
// ./src/containers/PruebaToken.js